import { render, staticRenderFns } from "./questionInvestigation.vue?vue&type=template&id=930f85fc&scoped=true"
import script from "./questionInvestigation.vue?vue&type=script&lang=js"
export * from "./questionInvestigation.vue?vue&type=script&lang=js"
import style0 from "./questionInvestigation.vue?vue&type=style&index=0&id=930f85fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930f85fc",
  null
  
)

export default component.exports